import React from "react";
import { Input } from "@progress/kendo-react-inputs";
import { Field } from "@progress/kendo-react-form";
import { connect } from "react-redux";

class CLInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
    };
  }
  componentDidMount() {
    if (this.props.isEditMode) {
      this.setState({
        value: this.props.task.checklistTask.value,
      });
    }
  }

  onInputChange = (event) => {
    let obj = {
      templateName: this.props.templateName,
      sequence: this.props.sequence,
      value: event.target.value,
    };
    this.props.onChange(obj);
  };

  render() {
    let child = null;
    if (this.props.isEditMode) {
      child = (
        <Field
          style={{
            padding: 5,
          }}
          name={"input" + this.props.sequence}
          component={Input}
          defaultValue={this.props.task.checklistTask.value}
          value={this.state.value}
          disabled={this.props.isDeleteMode}
          onChange={this.onInputChange}
        />
      );
    } else {
      child = (
        <Field
          style={{
            padding: 5,
          }}
          name={"input" + this.props.sequence}
          component={Input}
          defaultValue={this.state.value}
          value={this.state.value}
          disabled={this.props.isDeleteMode}
          onChange={this.onInputChange}
        />
      );
    }

    let panel = (
      <>
        <tr className={"k-master-row"}>
          <td style={{ paddingLeft: 5 }}>
            {this.props.task.taskTemplate.name}
          </td>
          <td style={{ paddingLeft: 5 }}>
            {this.props.task.taskTemplate.description}
          </td>
          <td
            style={{
              paddingLeft: 5,
              verticalAlign: "top",
            }}
          >
            <div className={"checklistBoxes"}>{child}</div>
          </td>
        </tr>
      </>
    );
    return <React.Fragment>{panel}</React.Fragment>;
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CLInput);
